import React from 'react'
import { priceChannels, PriceSelectionProvider } from 'modules/priceSelection'

import { Text } from 'components/dataDisplay'

import OrderItemBase from 'compositions/orderItems/OrderItemBase/OrderItemBase'
import OrderProductBase from 'compositions/orderItems/OrderProductBase/OrderProductBase'
import OrderItemRemoveButton from 'compositions/orderItems/OrderItemRemoveButton/OrderItemRemoveButton'

import messages from './messages'


type QueueProductOrderItemProps = {
  className?: string
  data: OrderItems.QueueProduct
  withRemoveButton?: boolean
}

const QueueProductOrderItem: React.FunctionComponent<QueueProductOrderItemProps> = (props) => {
  const { className, data, withRemoveButton } = props
  const { id, brand, name, size, image, rebrandImage, price, category, gender, fullName, quantity, offer } = data

  const productTypeNode = offer !== 'GIFT_FOR_BUY_QUEUE' ? (
    <Text
      className="mb-8"
      style="h9"
      message={messages.productType}
    />
  ) : null

  return (
    <PriceSelectionProvider channel={priceChannels.buyQueue}>
      <OrderItemBase className={className} data-testid="orderQueueItem">
        {
          withRemoveButton && (
            <OrderItemRemoveButton
              input={{
                queueItems: [
                  {
                    queueItemId: id,
                  },
                ],
              }}
              metadata={{
                productType: 'Ecommerce',
                placement: 'Drawer cart',
                productId: id,
                productBrand: brand,
                productFullName: fullName,
                productCategory: category,
                productVolume: size,
                productGender: gender,
              }}
            />
          )
        }
        <OrderProductBase
          image={image}
          rebrandImage={rebrandImage}
          name={name}
          brand={brand}
          price={price}
          quantity={quantity}
          size={size}
          beforeNode={productTypeNode}
        />
      </OrderItemBase>
    </PriceSelectionProvider>
  )
}


export default QueueProductOrderItem
